import { FC } from 'react';
import { BarRectangleItem } from 'recharts/types/cartesian/Bar';

interface BarWithBorderProps extends BarRectangleItem {
  borderColor: string;
  dataKey: string;
}

const BarWithBorder: FC<BarWithBorderProps> = ({
  borderColor,
  dataKey,
  fill,
  height,
  value,
  width,
  x,
  y,
}) => {
  // Do not display Bar if no data
  if (
    value === null ||
    x === undefined ||
    width === undefined ||
    height === undefined ||
    y === undefined
  ) {
    return null;
  }

  const barHeight = height + 5;
  // Create a gap between Bar categories (= dataKey)
  const startX = (dataKey === 'earnings' ? -3 : 3) + parseFloat(x.toString());
  const startY = parseFloat(y.toString());

  // Offset to hide radius in the bottom
  const bottomOffsetValue = 5;
  const bottomOffset = {
    clipPath: `inset(0px 0px ${bottomOffsetValue}px 0px)`,
  };

  // Offset the background rectangle to appear like a border
  const borderWidth = 2;

  // Offset to adjust the position of the background rectangle
  const backgroundRectanglePositionOffset = borderWidth / 2;

  return (
    <g>
      {/* Background rectangle acting like a border */}
      <rect
        fill={borderColor}
        height={barHeight + bottomOffsetValue + borderWidth}
        rx="6"
        style={bottomOffset}
        width={width + borderWidth}
        x={startX - backgroundRectanglePositionOffset}
        y={startY - backgroundRectanglePositionOffset}
      />
      {/* Fill rectangle */}
      <rect
        fill={fill}
        height={barHeight + bottomOffsetValue}
        rx="5"
        style={bottomOffset}
        width={width}
        x={startX}
        y={startY}
      />
    </g>
  );
};

export default BarWithBorder;
